import { extendTheme } from '@mui/joy/styles';

const theme = extendTheme({
  colorSchemes: {
    light: {
      palette: {
        primary: {
          50: '#eff6ff',
          100: '#d0e2ff',
          200: '#a1c4fd',
          300: '#7ab8fa',
          400: '#529df6',
          500: '#3b82f6', // blu brand
          600: '#2e6cd1',
          700: '#2355aa',
          800: '#1a407e',
          900: '#142d5a',
        },
        danger: {
          500: '#ef4444', // rosso per Logout
          600: '#dc2626',
          700: '#b91c1c',
        },
        neutral: {
          100: '#f5f7fa',
          300: '#cbd5e1',
          500: '#64748b',
          700: '#334155',
          900: '#1e293b',
        },
      },
    },
    dark: {
      palette: {
        primary: {
          50: '#dbeafe',
          100: '#bfdbfe',
          200: '#93c5fd',
          300: '#60a5fa',
          400: '#3b82f6',
          500: '#2563eb',
          600: '#1d4ed8',
          700: '#1e40af',
          800: '#1e3a8a',
          900: '#17275a',
        },
        danger: {
          500: '#f87171',
          600: '#ef4444',
          700: '#b91c1c',
        },
        warning: {
          500: '#facc15',
          600: '#eab308',
          700: '#a16207',
        },
        neutral: {
          100: '#121b2f',
          300: '#1e293b',
          500: '#64748b',
          700: '#94a3b8',
          900: '#e2e8f0',
        },
        background: {
          default: '#121212',
          surface: '#121212',  // **qui la modifica per surface**
        },
      },
    },
  },
  radius: {
    sm: '6px',
    md: '12px',
    lg: '18px',
  },
  fontFamily: {
    body: '"Inter", sans-serif',
    display: '"Inter", sans-serif',
  },
});

export default theme;
